import { createReducer, on } from '@ngrx/store';

import { parametersForMemberLockedTable } from '../../modules/shared/constants/parameters.for.calls.constants';
import { IMemberDataContentSets } from '../../modules/shared/interfaces/member/member-set-paging.interface';
import * as MemberProjectsLockedActions from '../actions/member-projects-locked.actions';

export interface MemberPojectsLockedState {
  value: IMemberDataContentSets;
  sort: string;
  isScrolling: boolean;
  isSearching: boolean;
  searchParam: string;
}

const initialState: MemberPojectsLockedState = {
    value: {
      content: [],
      first: true,
      last: false,
      number: 0,
      numberOfElements: 0,
      size: 0,
      totalElements: 0,
      totalPages: 1,
      sort: {
        ascending: true,
        descending: false,
        direction: 'ASC',
        ignoreCase: false,
        nullHandling: 'NATIVE',
        property: 'lastExported'
      }
    },
    sort: parametersForMemberLockedTable.sort,
    isScrolling: false,
    searchParam: '',
    isSearching: false
};

export const memberProjectsLockedDataReducer = createReducer<MemberPojectsLockedState>(
  initialState,
  on(MemberProjectsLockedActions.LoadMemberProjectsLocked, (state: MemberPojectsLockedState, { sort }) => {
    return {
      ...state,
      sort,
      isScrolling: false,
      isSearching: false,
      searchParam: ''
    };
  }),
  on(MemberProjectsLockedActions.SortMemberProjectsLocked, (state: MemberPojectsLockedState, { sort }) => {
    return {
      ...state,
      sort,
      isScrolling: false
    };
  }),
  on(MemberProjectsLockedActions.ScrollMemberProjectsLocked, (state: MemberPojectsLockedState, { sort }) => {
    return {
      ...state,
      sort,
      isScrolling: true,
      isSorting: false
    };
  }),
  on(MemberProjectsLockedActions.SearchMemberProjectsLocked, (state: MemberPojectsLockedState, { search }) => {
    return {
      ...state,
      isScrolling: false,
      isSearching: true,
      searchParam: search
    };
  }),
  on(MemberProjectsLockedActions.SearchSortMemberProjectsLocked, (state: MemberPojectsLockedState, { sort }) => {
    return {
      ...state,
      sort,
      isScrolling: false
    };
  }),
  on(MemberProjectsLockedActions.SearchScrollMemberProjectsLocked, (state: MemberPojectsLockedState, { search }) => {
    return {
      ...state,
      isScrolling: true,
      isSearching: true,
      searchParam: search
    };
  }),
  on(MemberProjectsLockedActions.LoadMemberProjectsLockedDataSuccessAction, (
    state: MemberPojectsLockedState, { memberProjectLockedTableItems }) => {
      const value = { ...memberProjectLockedTableItems };

      if (state.isScrolling) {
        value.content =
          state.value.content.concat(memberProjectLockedTableItems.content);
      }

      return {
        ...state,
        value
      };
  })
);

export const getMemberTableProjectsLocked = (state: MemberPojectsLockedState) => state;
export const getMemberTableSortSearchParamLocked = (state: MemberPojectsLockedState) => {
  return {
  sort: state.sort,
  searchParam: state.searchParam
  };
};
